// Phone layout for <Infographic> figures (inline SVG).
//
// Below 640px a figure renders in a horizontally scrollable container instead
// of being shrunk to the screen width, so its text stays legible. The SVG
// keeps its viewBox; only its rendered width changes.
//
// FIGURE_SCROLL_MIN_WIDTH is the SVG's minimum rendered width on phones. The
// floor is 720px, raised so that the smallest text in the widest figure still
// renders at FIGURE_MIN_TEXT_PX or more:
//   rendered text px = font-size (SVG units) x rendered width / viewBox width
//   AppRepresentativeDecision: 940 wide, smallest text 12.5 -> 940 x 11 / 12.5 = 827.2
// figureScroll.test.mjs checks every figure in src/content/figures/ against it.
export const FIGURE_SCROLL_FLOOR = 720;
export const FIGURE_MIN_TEXT_PX = 11;
export const FIGURE_SCROLL_MIN_WIDTH = 828;
export const FIGURE_SCROLL_BREAKPOINT = 640;

// Standalone SVG for "View full size". `markup` is the figure serialised as
// XML (XMLSerializer, which also adds the SVG namespace). The page's font is
// written in as a <style> element, since the figures use fontFamily: inherit.
export const standaloneSvg = (markup, fontFamily) => {
  const font = (fontFamily || 'system-ui, sans-serif').replace(/[<>&]/g, '');
  const style = `<style>svg { font-family: ${font}; background: #ffffff; }</style>`;
  return markup.replace(/^(<svg\b[^>]*>)/, `$1${style}`);
};
